import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmp5yhy27y: FaireProductEntity = {
  token: "p_fmp5yhy27y",
  type: "product",
  name: "SMARTIES - Candy Necklaces 21g (24 CT)",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b6d3a1f877a6bcff5f32d65dbb5a68f87f81c1842c85b91e08aa560109a39fe4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca24516e29991b57e48720868a3498da8173e1f3185146aabd65da9226528901.jpeg",
    "https://cdn.faire.com/fastly/e5eb478dfd6eb1770f992ac5c26596f54b3d75b66a745576be2d1d9cfed740d3.png",
    "https://cdn.faire.com/fastly/2817ad2f20888282e7715a93be084fa26d7a37d285722ccab53332bd23eed693.jpeg",
  ],
  priceDollars: 21,
  description:
    "Sweet, wearable, and nostalgic — Smarties Candy Necklaces are the ultimate fun snack 📿🍬\n\nEach necklace features colorful Smarties candy beads strung on a stretchy cord, combining the classic sweet-and-tangy fruity flavor with an interactive, wearable twist. It’s candy you can wear, share, and snack on anytime.\n\nPerfect for party favors, retail displays, and impulse purchases, this 24-count box is a proven crowd-pleaser for kids and nostalgic adults alike.\n\n\n\n\n\n🔥 Why Customers Love It\n\n• 📿 Wearable candy = fun + interactive\n• 🍬 Classic Smarties fruity, tangy flavor\n• 🎉 Perfect for parties, piñatas & giveaways\n• 📦 24 individually wrapped necklaces\n• 🌈 Bright pastel colors = strong visual appeal\n• 🌱 Vegan, gluten-free, allergen-friendly\n\nSmarties necklaces combine colorful candy beads with classic fruit flavors, making them both a snack and an accessory\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:52.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
